var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { FiAlertCircle, FiCheckCircle, FiChevronDown, FiChevronUp, FiClock, FiXCircle } from 'react-icons/fi';
import Service from '../../services/Service';
import Loading from '../Loading';
import TopNavigation from '../TopNavigation';
import * as S from './styles';
import { DEFAULT_POLLING_INTERVAL_MS, getPollingInterval, getStatusPresentation } from './utils';
import { useTranslation, formatDate } from '../../i18n';
var KNOWN_STATUSES = new Set([
    'APPROVED', 'REJECTED', 'REFUSED', 'PROCESSING', 'IN_PROCESS', 'IN_PROGRESS',
    'PENDING', 'PARTIAL', 'ERROR', 'NEW',
]);
var SERVICE_FIELD_ALIASES = new Set([
    'state',
    'sex',
    'mother_name',
    'rg_issuer',
    'father_name',
    'cnh_expiration',
    'cnh_category',
    'cnh_number',
    'rg_number',
    'name',
    'cnh_paid_activity',
    'cnh_renach',
    'cnh_doc_emission_place',
    'classification',
    'doc_type',
    'file_type',
    'nationality',
    'valid_date',
    'dt_rg_issue',
    'cnh_last_emission_date',
    'cnh_first_qualification_date',
    'birth_date',
    'issue_date',
    'cpf',
    'registration_number',
    'doc_emission_place',
    'issue_country',
    'passaport_type',
    'passaport_number',
    'authority',
    'naturality',
    'is_organ_donor',
    'via',
    'observations',
    'rne_valid_date',
    'rnm_number',
    'rne_number',
    'residence_period',
    'issue_body',
    'entry_date',
    'result_liveness_3d',
]);
var SERVICE_NAME_ALIASES = new Set([
    'SERVICE_OCR',
    'SERVICE_LIVENESS_3D_AWS',
    'SERVICE_FACE_MATCH',
]);
var SERVICE_MESSAGE_KEYS = new Set([
    'SERVICE_OCR__APPROVED',
    'SERVICE_OCR__NEW',
    'SERVICE_OCR__CANCELED',
    'SERVICE_OCR__IN_PROCESS',
    'SERVICE_LIVENESS_3D_AWS__APPROVED',
    'SERVICE_LIVENESS_3D_AWS__REFUSED',
    'SERVICE_LIVENESS_3D_AWS__IN_PROCESS',
    'SERVICE_FACE_MATCH__APPROVED',
    'SERVICE_FACE_MATCH__APPROVED_FALLBACK',
    'SERVICE_FACE_MATCH__NEW',
    'SERVICE_FACE_MATCH__REFUSED',
    'SERVICE_FACE_MATCH__ERROR',
]);
// Captura uma porcentagem na mensagem do serviço, ex.: "99.98%", "88,5 %".
var PERCENTAGE_REGEX = /\d+(?:[.,]\d+)?\s*%/;
var getServiceFieldLabelKey = function (alias) {
    return SERVICE_FIELD_ALIASES.has(alias) ? "serviceFields.".concat(alias) : null;
};
var getServiceNameKey = function (alias) {
    return SERVICE_NAME_ALIASES.has(alias) ? "serviceNames.".concat(alias.toLowerCase()) : null;
};
var getServiceMessageKey = function (alias, status) {
    var composed = "".concat(alias, "__").concat((status || '').toUpperCase());
    return SERVICE_MESSAGE_KEYS.has(composed) ? "serviceMessages.".concat(composed.toLowerCase()) : null;
};
var ResultStatus = function (_a) {
    var status = _a.status;
    var t = useTranslation().t;
    var _b = getStatusPresentation(status), labelKey = _b.labelKey, rawLabel = _b.rawLabel, kind = _b.kind;
    var label = labelKey ? t(labelKey) : (rawLabel || '');
    var normalized = (status || '').toUpperCase();
    var Icon = kind === 'success'
        ? FiCheckCircle
        : kind === 'progress'
            ? FiClock
            : (normalized === 'REJECTED' || normalized === 'REFUSED')
                ? FiXCircle
                : FiAlertCircle;
    return React.createElement(S.Status, { statusKind: kind },
        React.createElement(Icon, { "aria-hidden": "true" }),
        label);
};
var ServiceStatus = function (_a) {
    var status = _a.status;
    var t = useTranslation().t;
    if ((status || '').toUpperCase() === 'NEW') {
        var label = t('result.statusNew');
        return React.createElement(S.StatusSpinner, { role: "status", "aria-label": label, title: label });
    }
    return React.createElement(ResultStatus, { status: status });
};
var ResultService = function (_a) {
    var service = _a.service, index = _a.index;
    var t = useTranslation().t;
    var fields = Array.isArray(service.fields) ? service.fields : [];
    var resolveFieldLabel = function (field) {
        var key = getServiceFieldLabelKey(field.field);
        return key ? t(key) : field.label;
    };
    var resolveServiceName = function () {
        var key = getServiceNameKey(service.serviceAlias || '');
        return key ? t(key) : service.serviceName;
    };
    var resolveFaceMatchApprovedMessage = function () {
        var percentageMatch = (service.statusMessage || '').match(PERCENTAGE_REGEX);
        if (percentageMatch) {
            return t('serviceMessages.service_face_match__approved', { score: percentageMatch[0].replace(/\s+/g, '') });
        }
        return t('serviceMessages.service_face_match__approved_fallback');
    };
    var resolveStatusMessage = function () {
        var alias = (service.serviceAlias || '').toUpperCase();
        var status = (service.status || '').toUpperCase();
        if (alias === 'SERVICE_FACE_MATCH' && status === 'APPROVED') {
            return resolveFaceMatchApprovedMessage();
        }
        var key = getServiceMessageKey(service.serviceAlias || '', service.status);
        return key ? t(key) : service.statusMessage;
    };
    var serviceName = resolveServiceName();
    var statusMessage = resolveStatusMessage();
    var expandable = fields.length > 0;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var detailsId = "step-result-service-".concat(index);
    var formattedDate = formatDate(service.createdDate);
    var heading = (React.createElement(React.Fragment, null,
        React.createElement(S.ServiceHeading, null,
            React.createElement(S.ServiceName, null, serviceName),
            statusMessage ? React.createElement(S.ServiceMessage, null, statusMessage) : null,
            formattedDate ? React.createElement(S.ServiceDate, { dateTime: service.createdDate || undefined }, formattedDate) : null),
        React.createElement(ServiceStatus, { status: service.status }),
        expandable ? (open ? React.createElement(FiChevronUp, { "aria-hidden": "true" }) : React.createElement(FiChevronDown, { "aria-hidden": "true" })) : null));
    return (React.createElement(S.Card, null,
        expandable ? (React.createElement(S.CardHeader, { type: "button", "aria-expanded": open, "aria-controls": detailsId, onClick: function () { return setOpen(function (value) { return !value; }); } }, heading)) : React.createElement(S.StaticCardHeader, null, heading),
        expandable && open ? (React.createElement(S.CardDetails, { id: detailsId }, fields.map(function (field, fieldIndex) { return (React.createElement(S.FieldRow, { key: "".concat(field.field, "-").concat(fieldIndex) },
            React.createElement(S.FieldLabel, null, resolveFieldLabel(field)),
            field.field === 'selfie_liveness_3d' ? (React.createElement(S.FieldLink, { href: field.value, target: "_blank", rel: "noopener noreferrer" }, " image - selfie_liveness_3d "))
                : (React.createElement(S.FieldValue, null, field.value)))); }))) : null));
};
var StepResult = function (_a) {
    var step = _a.step;
    var t = useTranslation().t;
    var _b = useSelector(function (state) { return state.form; }), form = _b.form, formInfo = _b.formInfo;
    var currentStep = form.steps[step];
    var tokenOnboarding = formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding;
    var _c = React.useState(null), result = _c[0], setResult = _c[1];
    var _d = React.useState(true), loading = _d[0], setLoading = _d[1];
    var _e = React.useState(false), requestError = _e[0], setRequestError = _e[1];
    var _f = React.useState(null), personName = _f[0], setPersonName = _f[1];
    var _g = React.useState(null), foundFace = _g[0], setFoundFace = _g[1];
    var timerRef = React.useRef(null);
    var controllerRef = React.useRef(null);
    var mountedRef = React.useRef(false);
    var inFlightRef = React.useRef(false);
    var resultRef = React.useRef(null);
    var intervalRef = React.useRef(DEFAULT_POLLING_INTERVAL_MS);
    var reportedStatusesRef = React.useRef(new Set());
    var clearTimer = React.useCallback(function () {
        if (timerRef.current !== null) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    var validateStatus = function (status) {
        var normalized = (status || '').toUpperCase();
        if (normalized &&
            !KNOWN_STATUSES.has(normalized) &&
            !reportedStatusesRef.current.has(normalized)) {
            reportedStatusesRef.current.add(normalized);
            Sentry.captureMessage("Status desconhecido no step RESULT: ".concat(normalized), 'warning');
        }
    };
    var fetchResultRef = React.useRef(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); });
    var scheduleNext = React.useCallback(function (delay) {
        clearTimer();
        if (document.visibilityState === 'hidden')
            return;
        timerRef.current = window.setTimeout(function () { return fetchResultRef.current(); }, delay);
    }, [clearTimer]);
    var fetchResult = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var controller, response, normalized, error_1, lastResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tokenOnboarding || inFlightRef.current) {
                        if (!tokenOnboarding && mountedRef.current) {
                            setLoading(false);
                            setRequestError(true);
                        }
                        return [2 /*return*/];
                    }
                    clearTimer();
                    inFlightRef.current = true;
                    controller = new AbortController();
                    controllerRef.current = controller;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Service.getStepResult({ tokenOnboarding: tokenOnboarding, signal: controller.signal })];
                case 2:
                    response = _a.sent();
                    if (!mountedRef.current)
                        return [2 /*return*/];
                    if (response.tokenOnboarding !== tokenOnboarding) {
                        throw new Error('Token de onboarding divergente na resposta de resultados');
                    }
                    normalized = __assign(__assign({}, response), { services: Array.isArray(response.services)
                            ? response.services.map(function (service) { return (__assign(__assign({}, service), { fields: Array.isArray(service.fields) ? service.fields : [] })); })
                            : [] });
                    resultRef.current = normalized;
                    intervalRef.current = getPollingInterval(normalized.pollingIntervalSeconds);
                    setResult(normalized);
                    setRequestError(false);
                    setLoading(false);
                    if (normalized.pollingRecommended && !normalized.finished) {
                        scheduleNext(intervalRef.current);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    if (!mountedRef.current || controller.signal.aborted)
                        return [2 /*return*/];
                    setRequestError(true);
                    setLoading(false);
                    Sentry.captureException(error_1);
                    lastResult = resultRef.current;
                    if ((lastResult === null || lastResult === void 0 ? void 0 : lastResult.pollingRecommended) && !lastResult.finished) {
                        scheduleNext(intervalRef.current);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    if (controllerRef.current === controller) {
                        controllerRef.current = null;
                        inFlightRef.current = false;
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [clearTimer, scheduleNext, tokenOnboarding]);
    fetchResultRef.current = fetchResult;
    React.useEffect(function () {
        mountedRef.current = true;
        fetchResult();
        var handleVisibilityChange = function () {
            if (document.visibilityState === 'hidden') {
                clearTimer();
                return;
            }
            var lastResult = resultRef.current;
            if ((lastResult === null || lastResult === void 0 ? void 0 : lastResult.pollingRecommended) && !lastResult.finished)
                fetchResultRef.current();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            var _a;
            mountedRef.current = false;
            clearTimer();
            (_a = controllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
            controllerRef.current = null;
            inFlightRef.current = false;
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [clearTimer, fetchResult]);
    React.useEffect(function () {
        var _a;
        if (!result)
            return;
        validateStatus(result.status);
        validateStatus(result.result);
        (_a = result.services) === null || _a === void 0 ? void 0 : _a.forEach(function (service) {
            var _a, _b;
            validateStatus(service.status);
            if (service.serviceAlias && service.status &&
                service.status === 'APPROVED') {
                switch (service.serviceAlias.toUpperCase()) {
                    case 'SERVICE_OCR':
                        (_a = service.fields) === null || _a === void 0 ? void 0 : _a.forEach(function (field) {
                            if (field.field === 'name') {
                                setPersonName(field.value);
                            }
                        });
                        break;
                    case 'SERVICE_LIVENESS_3D_AWS':
                        (_b = service.fields) === null || _b === void 0 ? void 0 : _b.forEach(function (field) {
                            if (field.field === 'selfie_liveness_3d') {
                                setFoundFace(field.value);
                            }
                        });
                        break;
                    default:
                        break;
                }
            }
        });
    }, [result]);
    var retry = function () {
        setLoading(true);
        setRequestError(false);
        fetchResult();
    };
    return (React.createElement(S.Container, null,
        React.createElement(TopNavigation, { showBackButton: currentStep.goBack, title: currentStep.showStepName ? currentStep.stepName : '', headerTransparent: currentStep.headerTransparent }),
        React.createElement(S.Content, null,
            loading && !result ? React.createElement(Loading, null) : null,
            !loading && requestError && !result ? (React.createElement(React.Fragment, null,
                React.createElement(S.StateMessage, null, t('result.loadFailed')),
                React.createElement(S.RetryButton, { type: "button", onClick: retry }, t('common.tryAgain')))) : null,
            result ? (React.createElement(React.Fragment, null,
                React.createElement(S.Summary, { "aria-live": "polite" },
                    React.createElement(S.Title, null, t('result.title')),
                    foundFace ? React.createElement(S.PersonLiveness, { src: foundFace, alt: t('result.livenessAlt') }) : null,
                    personName ? React.createElement(S.PersonName, null, personName) : null,
                    React.createElement(ResultStatus, { status: result.result }),
                    !result.finished ? React.createElement(S.Updating, null, t('result.updating')) : null),
                requestError ? React.createElement(S.Warning, null, t('result.updateFailed')) : null,
                result.services.length === 0 ? (React.createElement(S.StateMessage, null, t('result.empty'))) : (React.createElement(S.Services, { "aria-label": t('result.servicesLabel') }, result.services.map(function (service, index) { return (React.createElement(ResultService, { key: "".concat(service.serviceAlias, "-").concat(index), service: service, index: index })); }))))) : null,
            React.createElement(S.ButtonContainer, null, form.steps[step].fields.map(function (field, index) {
                if (field.visible) {
                    switch (field.field) {
                        case "info_button":
                        case "contact_button":
                            return React.createElement(S.OptionButton, { type: "button", onClick: function () {
                                    if (field.value) {
                                        window.open(field.value || "", "_blank", "noopener,noreferrer");
                                    }
                                }, key: index }, field.label);
                        default:
                            return null;
                    }
                }
            })))));
};
export default StepResult;
